import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	enablePagesLinkText: {
		id: 'navigation-shortcuts.common.messages.pages-messages.enable-pages-link-text',
		defaultMessage:
			'Create, share and collaborate on all your project docs in one place with Confluence pages.',
		description: '',
	},
});

export default messages;
